import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class ModuleCertificatesStateModel extends PaginatedSubentityStateModel {
    constructor() {
        super('ModuleCertificatesStateModel');
    }
}
